import Component from '@glimmer/component';

export interface ScansFileCardSignature {
  // The arguments accepted by the component
  Args: {
    title: string;
    description: string;
    reportType: 'VERIFIED' | 'AUTO_GENERATED';
    date: string;
    fileType: 'PDF' | 'XLS' | 'DOCX' | 'PPTX' | 'ZIP';
    link: string;
  };
  // Any blocks yielded by the component
  Blocks: {
    default: [];
  };
  // The element to which `...attributes` is applied in the component template
  Element: null;
}

export default class ScansFileCard extends Component<ScansFileCardSignature> {
  get filePillStyle() {
    if (this.args.fileType === 'PDF')
      return 'bg-red-500 border-red-500 text-white';
    if (this.args.fileType === 'DOCX')
      return 'bg-blue-500 border-blue-500 text-white';
    if (this.args.fileType === 'XLS')
      return 'bg-green-500 border-green-500 text-white';
    if (this.args.fileType === 'PPTX')
      return 'bg-orange-500 border-orange-500 text-white';
    if (this.args.fileType === 'ZIP')
      return 'bg-yellow-500 border-yellow-500 text-white';
    return 'bg-gray-50 text-gray-500';
  }
}
